export const routes = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Payments",
    link: "/#",

    subRoutes: [
      {
        name: 'Admission Fees',
        link: '/admission_fees',
      },
      {
        name: 'Yearly Dues',
        link: '/yearly_dues',
      },
      {
        name: '2M2',
        link: '/main_2m2_payments',
      },
    ]
  },
  {
    name: "Join Us",
    link: "/registration",
  },
   {
    name: "Contact Us",
    link: "/contact",
  },
];
